// extracted by mini-css-extract-plugin
export var brand = "_1g-9";
export var button = "_1g-0";
export var chevron = "_1g-v";
export var chevronButton = "_1g-w";
export var content = "_1g-n";
export var danger = "_1g-g";
export var dangerOutlined = "_1g-h";
export var dark = "_1g-l";
export var darkTheme = "_1g-c";
export var extraSmall = "_1g-4";
export var fullWidth = "_1g-8";
export var ghost = "_1g-d";
export var gray = "_1g-t";
export var icon = "_1g-p";
export var iconButton = "_1g-s";
export var iconButtonBorder = "_1g-x";
export var iconButtonBorderDark = "_1g-y";
export var iconButtonBorderLight = "_1g-z";
export var iconLeft = "_1g-q";
export var iconRight = "_1g-r";
export var large = "_1g-1";
export var light = "_1g-m";
export var medium = "_1g-2";
export var micro = "_1g-5";
export var nano = "_1g-7";
export var outlined = "_1g-k";
export var pending = "_1g-a";
export var primary = "_1g-i";
export var shadow = "_1g-o";
export var small = "_1g-3";
export var solidLight = "_1g-e";
export var solidLightBrand = "_1g-f";
export var spinner = "_1g-u";
export var transparent = "_1g-j";
export var warning = "_1g-b";
export var wideNano = "_1g-6";